import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class TransitionLine {
    constructor() {
        this.lines = document.querySelectorAll('.transitionLine .line');
        if (this.lines.length) this.init();
    }

    init() {
        this.lines.forEach(line => {
            gsap.to(line, {
                scaleY: 1,
                ease: "power1.ease",
                scrollTrigger: {
                    trigger: line.parentElement,
                    start: "20% 95%",
                    end: "100% 70%",
                    scrub: true,
                }
            });
        });
    }
}
